var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessCard = function SvgBusinessCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Business_Card_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Business_Card_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 35,
    y: 51,
    width: 45,
    height: 49,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 17.5,
    cy: 13.5,
    r: 19.5,
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 18,
    y: 30,
    width: 58,
    height: 37,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 59,
    height: 38,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 50,
    y: 25,
    width: 16,
    height: 15,
    rx: 1,
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 42.378h27.243H15Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 42.378h27.243",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 46.5h13-13Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 46.5h13",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 50.5h13-13Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 50.5h13",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 54.5h13-13Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 54.5h13",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgBusinessCard;